<script>
	import { onMount, createEventDispatcher } from 'svelte'
	import { Link, navigateTo } from 'yrv'

	import axios from 'axios'
	import wait from '../../libs/wait'

	import FadeinFX from '../../components/FX/FadeinFx.svelte'
	import AdminLayout from '../../layouts/AdminLayout.svelte'
	import Sidepanel from '../../components/Sidepanel/Sidepanel.svelte'
	import SidepanelContent from './VacationsSideContent.svelte'
	import SvelteFullCalendar from '../../components/SvelteFullCalendar/SvelteFullCalendar.svelte'
	import { background, notifySuccess } from '../../components/Notifications/AppNotifications.svelte'
	import VacationsEditor from './VacationsEditor.svelte'

	export let id

	let screenReady = false,
		initd = false,
		sideModel = {},
		calendarRef = null,
		calendarTimer = null,
		viewBusy = false,
		startDate = 0,
		endDate = 0,
		editorShown = false,
		editorModel = null,
		editorCreate = false

	const calendarOptions = {
		droppable: true,
		editable: true,
		selectable: true,
		selectMirror: true,
		eventResizableFromStart: true,
		eventLimit: false,
		headerToolbar: {
			start: '',
			center: '',
			end: ''
		},
		eventClassNames: (info) => `holiday-type-${info.event.extendedProps.type}`,
		select: (info) => {
			// console.log('select', info)
			handleCalendarEvent(true, info)
		},
		eventResize: (info) => {
			// console.log('eventResize', info)
			handleCalendarEvent(false, info)
		},
		// eventDisplay: 'block',
		eventClick: (info) => {
			// console.log('eventClick', info, info.event.extendedProps)
			handleCalendarEvent(false, info)
		},
		eventDrop: (info) => {
			// console.log('eventDrop', info, info.event.start.getTime())
			handleCalendarEvent(false, info)
		}
	}

	function handleCalendarEvent(isCreate, info) {
		const { start, end } = isCreate ? info : info.event
		const data = {
			...(isCreate ? {} : info.event.extendedProps),
			nextStart: start.getTime(),
			nextEnd: end.getTime()
		}

		showEditor(isCreate, data)
	}

	const onQuery = (event) => {
		const { detail } = event
		// console.log ('onQuery', detail)
		if (detail.type === 'op-activity') {
			window.open(`/api/activity/listByOperator?operator=${detail.operator}&month=${detail.month}&output=html`)
		} else if (detail.type === 'month-overtime') {
			window.open(`/api/query/monthOvertime?month=${detail.month}&category=${id}&output=html`)
		}
	}

	const onCalendarMonthChange = (event) => {
		// console.log ('onCalendarMonthChange', event.detail)
		if (calendarRef && event.detail === 'prev') calendarRef.prev()
		else if (calendarRef && event.detail === 'next') calendarRef.next()

		viewBusy = true
	}

	const afterCalendarPeriodchange = (event) => {
		const { start, end, view } = event.detail

		// console.log ('viewtitle', view.getCurrentData ().viewTitle)
		sideModel.currentMonth = view.getCurrentData().viewTitle

		if (calendarRef) calendarRef.removeAllEvents()

		if (calendarTimer) {
			clearTimeout(calendarTimer)
			calendarTimer = null
		}

		calendarTimer = setTimeout(
			() => {
				fetchHolidays({ start, end, view })
			},
			initd ? 400 : 0
		)
		initd = true
	}

	const fetchHolidays = async (info) => {
		var start = info !== undefined ? info.view.activeStart.getTime() : undefined,
			end = info !== undefined ? info.view.activeEnd.getTime() : undefined

		if (calendarRef && calendarRef.view) {
			start = calendarRef.view.activeStart.getTime()
			end = calendarRef.view.activeEnd.getTime()
		}

		background(true)
		const result = await axios.request({
			method: 'get',
			url: `/api/holidays/olist?start=${start}&end=${end}`
		})
		calendarRef.addEventSource(
			result.data.holidays.map((it) => {
				return {
					title: it.name + ' / ' + it.description,
					start: it.start,
					end: it.end,
					hid: it.id,
					name: it.name,
					type: it.type,
					user: it.user,
					originalStart: it.start,
					originalEnd: it.end,
					allDay: true
				}
			})
		)
		background(false)
	}

	const fetchModel = async (sectorId) => {
		await wait(200)
		screenReady = true
	}

	function showEditor(isCreate, data) {
		editorModel = data
		editorCreate = isCreate
		editorShown = true
	}

	function hideEditor() {
		editorShown = false
		editorCreate = false
		editorModel = null
	}

	function reloadCalendarData() {
		if (calendarRef) calendarRef.removeAllEvents()
		fetchHolidays()
	}

	function onSettled() {
		hideEditor()
		reloadCalendarData()
	}

	$: fetchModel(id)
</script>

<Sidepanel>
	<SidepanelContent data={sideModel} on:month-change={onCalendarMonthChange} />
</Sidepanel>
<AdminLayout classes="sidepanel">
	<div class="VacationsDashbard page-pad avoid-selection">
		{#if screenReady}
			<FadeinFX delay={300} delayOut={0}>
				<SvelteFullCalendar
					bind:ref={calendarRef}
					options={calendarOptions}
					on:period-change={afterCalendarPeriodchange}
				/>
			</FadeinFX>
		{/if}
	</div>
</AdminLayout>

{#if editorShown}
	<VacationsEditor data={editorModel} create={editorCreate} on:cancel={onSettled} on:saved={onSettled} />
{/if}

<style>
	.VacationsDashbard :global(.fc-header-toolbar) {
		margin-bottom: 0;
	}
	.VacationsDashbard :global(.holiday-type-0) {
		background-color: #3ad1b3;
		border-color: #3ad1b3;
	}
	.VacationsDashbard :global(.holiday-type-2) {
		background-color: #fe9392;
		border-color: #fe9392;
	}
	:global(a.fc-event) {
		border-radius: 2px;
		line-height: 10px;
	}
</style>
